import React from 'react';
import Section from '../common/Section';
import { Check, X } from 'lucide-react';

/**
 * Clear expectations panel.
 */
const WhatItIsSection = () => {
  const isStatements = [
    'Evidence based daily structure',
    'Two pathways: clinical or self guided',
    'HIPAA compliant and private',
  ];

  const isNotStatements = [
    'A replacement for professional treatment',
    'A crisis service',
    'A quick fix or 30 day program',
  ];

  return (
    <Section id="what-it-is" background="white" padding="md" panel={false} className="pt-2" style={{ backgroundColor: 'var(--cream-canvas)' }}>
      <div
        className="max-w-6xl mx-auto rounded-[28px] border p-6 sm:p-8 md:p-10"
        style={{
          backgroundColor: 'var(--surface-card)',
          borderColor: 'rgba(31, 42, 36, 0.08)',
          boxShadow: '0 18px 38px rgba(20, 48, 36, 0.08)',
        }}
      >
        <div className="mb-7">
          <h2 className="text-2xl sm:text-3xl font-extrabold" style={{ color: 'var(--text-primary)' }}>
            Clear expectations
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          <div className="rounded-3xl p-6 border" style={{ backgroundColor: 'var(--surface-soft-4)', borderColor: 'rgba(31, 42, 36, 0.08)' }}>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-2xl flex items-center justify-center" style={{ backgroundColor: 'rgba(45, 90, 71, 0.15)' }}>
                <Check size={20} style={{ color: 'var(--brand-green-deep)' }} />
              </div>
              <h3 className="text-lg font-extrabold" style={{ color: 'var(--text-primary)' }}>What it is</h3>
            </div>
            <ul className="space-y-3">
              {isStatements.map((s) => (
                <li key={s} className="flex items-start gap-3">
                  <Check size={18} className="mt-0.5 flex-shrink-0" style={{ color: 'var(--brand-green-deep)' }} />
                  <span style={{ color: 'var(--text-primary)' }}>{s}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-3xl p-6 border" style={{ backgroundColor: 'var(--surface-soft-1)', borderColor: 'rgba(31, 42, 36, 0.08)' }}>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-2xl flex items-center justify-center" style={{ backgroundColor: 'rgba(107, 114, 128, 0.1)' }}>
                <X size={20} style={{ color: 'var(--text-muted)' }} />
              </div>
              <h3 className="text-lg font-extrabold" style={{ color: 'var(--text-primary)' }}>What it is not</h3>
            </div>
            <ul className="space-y-3">
              {isNotStatements.map((s) => (
                <li key={s} className="flex items-start gap-3">
                  <X size={18} className="mt-0.5 flex-shrink-0" style={{ color: 'var(--text-muted)' }} />
                  <span style={{ color: 'var(--text-muted)' }}>{s}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default WhatItIsSection;
